// 2024-01-15 Moved from formsviewer.domain.js

export function webServiceInput(source, fragments) {
    return {
        source: source,
        fragments: fragments,
    };
}

// String, String, Boolean, String, String
export function webServiceInputFragment(
    match,
    replaceWith,
    sendAsString,
    filter,
    dataObject,
) {
    return {
        match: match,
        replaceWith: replaceWith,
        sendAsString: sendAsString,
        filter: filter,
        dataObject: dataObject,
    };
}
